import { DisplayProperties } from '@com-delta-idp/mnx-skymiles-shared';
import { CardCarouselBanner } from '../components/banner/models/banner.interfaces';
import { SimplePaginator } from '../components/simple-paginator/models/simple-paginator.interfaces';

export interface CardCarousel extends DisplayProperties {
  cards: CardCarouselBanner[];
  paginator: SimplePaginator;
  current: number;
}
